import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, api_service_path } from "./utils"

export const downloadAction = createApi({
    reducerPath: "downloadApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/${api_service_path.download}`,
        prepareHeaders: (headers) => {
            const current_user = localStorage.getItem("current_user") ? JSON.parse(localStorage.getItem("current_user")) : null
            if (current_user?.token) {
                headers.set(
                    "Authorization",
                    `Bearer ${current_user.token}`
                )
            }
            return headers
        }
    }),
    tagTypes: ["download"],
    endpoints: (builder) => ({
        downloadRegisterStudents: builder.query({
            query: ({
                class_ref,
                institution_ref
            }) => ({
                url: `/registered_students/${class_ref}/${institution_ref}`,
                method: "GET"
            })
        }),
        downloadAdmissionRecieved: builder.mutation({
            query: (data) => ({
                url: `/admission_recieved`,
                method: "POST",
                body: data,
                responseHandler: (response) => response.blob()
            })
        }),
        downloadAdmissionDocument: builder.mutation({
            query: (data) => ({
                url: "/admission_fee_receipt",
                method: "POST",
                body: data,
                responseHandler: (response) => response.blob()
            })
        }),
        downloadAdmitCard: builder.mutation({
            query: (data) => ({
                url: "/admit",
                method: "POST",
                body: data,
                responseHandler: (response) => response.blob()
            })
        }),
        downloadRegistrationPdf: builder.mutation({
            query: (data) => ({
                url: "/registration_response",
                method: "POST",
                body: data,
                responseHandler: (response) => response.blob()
            })
        }),
        downloadTimetable: builder.mutation({
            query: (data) => ({
                url: "/exam_time_table",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        downloadFeeReceipt: builder.mutation({
            query: (data) => ({
                url: "/generate_fee_receipt",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        downloadExcelFile: builder.mutation({
            query: (data) => ({
                url: "/download_registered_students_bulk",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        exportAdmitLinkBulk:builder.mutation({
            query:(data)=> ({
                url:"/export-excel",
                method:"POST",
                body:data,
                responseHandler:(res)=> {
                    if(res.ok){
                        return res.blob()
                    }else{
                        return res?.json()
                    }
                }
            })
        })
    })
})

export const {
    useLazyDownloadRegisterStudentsQuery,
    useDownloadAdmissionRecievedMutation,
    useDownloadAdmissionDocumentMutation,
    useDownloadAdmitCardMutation,
    useDownloadRegistrationPdfMutation,
    useDownloadTimetableMutation,
    useDownloadFeeReceiptMutation,
    useDownloadExcelFileMutation,

    useExportAdmitLinkBulkMutation
} = downloadAction